import {AString} from '@mintdata/mint-kit/api/values/AString';
import {AStringEnum} from '@mintdata/mint-kit/api/values/AStringEnum';

export class TimePrecision extends AStringEnum
{
    public constructor(value:AString)
    {
        super(value, TimePrecision.types);
    }

    public toString():string
    {
        return this.value ? this.value.toString() : null;
    }

    public static NONE = new AString('none');
    public static SECOND = new AString('second');
    public static MINUTE = new AString('minute');
    public static MILLISECOND = new AString('millisecond');

    public static types:Array<AString> = [
        TimePrecision.NONE,
        TimePrecision.MINUTE,
        TimePrecision.SECOND,
        TimePrecision.MILLISECOND
    ];

    public static none():TimePrecision
    {
        return new TimePrecision(TimePrecision.NONE);
    }

    public static minute():TimePrecision
    {
        return new TimePrecision(TimePrecision.MINUTE);
    }

    public static second():TimePrecision
    {
        return new TimePrecision(TimePrecision.SECOND);
    }

    public static millisecond():TimePrecision
    {
        return new TimePrecision(TimePrecision.MILLISECOND);
    }

    public static getValue(timePrecision:TimePrecision):number | undefined
    {
        switch( timePrecision.value.value )
        {
            case TimePrecision.NONE.value:
                return undefined;
            case TimePrecision.SECOND.value:
                return 1;
            case TimePrecision.MINUTE.value:
                return 0;
            case TimePrecision.MILLISECOND.value:
                return 2;
        }
    }

    public static fromAString(value:AString):TimePrecision
    {
        return new TimePrecision(value);
    }

}
